import type { Resource } from '../../';
export const general_errors_renderAlerts_errorName: Resource = {"default":"Error Name"};
